<template>
  <div class="h-screen overflow-y-auto bg-gray-50 px-4 py-6 scrollable-page">
    <div class="max-w-lg mx-auto flex flex-col justify-between">
      <!-- Header -->
      <div class="pb-4">
        <div class="text-center">
          <div class="search-bar">
            <div class="search-wrapper">
              <img src="/img/svg/search.svg" alt="search" class="search-icon w-4 h-4">
                <input
                type="text"
                :placeholder="$t('searchInList')"
                v-model="searchQuery"
                class="search-input"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Chats List -->
      <div
        v-if="pageLoading"
        class="chats-list-container pb-16 chats-skeleton-group"
        aria-hidden="true"
      >
        <div
          v-for="n in skeletonChatCount"
          :key="'chat-sk-' + n"
          class="chat-item"
        >
          <div class="chat-card px-3 py-2">
            <div class="flex gap-4 items-center w-full">
              <div class="skeleton-block skeleton-avatar"></div>
              <div class="flex-1 min-w-0">
                <div class="flex justify-between items-center mb-2">
                  <div class="skeleton-block skeleton-line skeleton-line-md"></div>
                  <div class="skeleton-block skeleton-line skeleton-line-date"></div>
                </div>
                <div class="skeleton-block skeleton-line skeleton-line-sm"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!pageLoading" class="chats-list-container pb-16">
        <div v-for="item in fConversations" :key="item.GetReceiver" class="chat-item">
          <div class="chat-card px-3 py-2 cursor-pointer" @contextmenu="openMenu($event, item)" v-on:click="goToDetail(item)">
            <div class="flex gap-4 items-center w-full">
              <!-- Avatar -->
              <div class="relative chat-avatar-wrap">
                <div class="w-12 h-12 rounded-full overflow-hidden border border-gray-200">
                  <img :src="item.ProcessThumb" class="w-full h-full object-cover" alt="Profile" />
                </div>
                <span v-if="item.isOnline" class="online-pulse-dot" aria-label="آنلاین"></span>
              </div>
              
              <!-- Content -->
              <div class="flex-1 min-w-0">
                <div class="flex justify-between items-center mb-1">
                  <h3 class="text-sm font-medium text-gray-700 truncate">{{item.ProcessName}}</h3>
                  <span class="text-xs text-gray-500 whitespace-nowrap">{{get_conversation_date(item)}}</span>
                </div>
                
                <div class="flex justify-between items-center">
                  <p v-if="item.typing_text == null" class="text-xs text-gray-500 truncate flex-1">
                    {{item.MessageText}}
                  </p>
                  <p v-else class="text-xs text-blue-500 truncate flex-1 italic">
                    {{item.typing_text}}
                  </p>
                  
                  <div v-if="item.UnReadCount != 0" class="bg-blue-500 text-white text-xs max-w-fit rounded-full w-5 h-5 flex items-center justify-center px-1.5 mr-2">
                    <span v-if="item.UnReadCount < 100">{{item.UnReadCount}}</span>
                    <span v-else>+99</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>

        <div
          v-if="loadingMore"
          class="chats-more-skeleton chats-more-skeleton-group"
          aria-hidden="true"
        >
          <div
            v-for="n in skeletonMoreCount"
            :key="'chat-sk-more-' + n"
            class="chat-item"
          >
            <div class="chat-card px-3 py-2">
              <div class="flex gap-4 items-center w-full">
                <div class="skeleton-block skeleton-avatar"></div>
                <div class="flex-1 min-w-0">
                  <div class="flex justify-between items-center mb-2">
                    <div class="skeleton-block skeleton-line skeleton-line-md"></div>
                    <div class="skeleton-block skeleton-line skeleton-line-date"></div>
                  </div>
                  <div class="skeleton-block skeleton-line skeleton-line-sm"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div
          v-if="showMenu"
          class="context-menu"
          :style="{ left: x + 'px', top: y + 'px' }"
        >
          <div class="menu-item" v-on:click="goToDetail(show_detail)">
            <span class="menu-icon">👁️</span>
            {{ $t('show') }}
          </div>
          <div class="menu-item" v-on:click="removeMessage()">
            <span class="menu-icon">🗑️</span>
            {{ $t('delete') }}
          </div>
        </div>
      </div>
      
      <infinite-loading @infinite="infiniteHandler">
        <span slot="spinner"></span>
        <div slot="no-more" class="text-center text-gray-400 text-xs py-4">{{ $t('no_record') }}</div>
      </infinite-loading>

      <!-- Floating New Chat Button -->
      <div v-if="!pageLoading" class="fixed bottom-32 left-6 z-50">
        <button 
          class="w-14 h-14 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors flex items-center justify-center"
          v-on:click="goToContact()"
        >
        <img src="/img/svg/new-chat.svg" alt="new message" class="w-8 h-8">
        </button>
      </div>

      <!-- Dialog -->
      <div
        v-if="dialog"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-999"
        @click="dialog = false"
      >
        <div class="bg-white rounded-xl max-w-sm w-full mx-4" @click.stop>
          <div class="p-6 text-center">
            <h3 class="text-lg font-bold text-gray-800 mb-4">حذف گفتگو</h3>
            <p class="text-gray-600 text-sm mb-6">{{ $t('sureToDeleteConversation') }}</p>
            <div class="flex gap-3">
              <button
                class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50"
                @click="dialog = false"
              >{{ $t('cancel') }}</button>
              <button
                class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg text-sm font-medium hover:bg-blue-600"
                @click="dialog = false"
              >{{ $t('ok') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Longpress from 'vue-longpress'
  import { bus } from '../../main.js'
  import Vue from 'vue'
  import InfiniteLoading from 'vue-infinite-loading'
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  export default {
    data () {
      return {
        conversations: [],
        fConversations: [],
        date_now: '',
        searchQuery: null,
        long: 0,
        startTime: 0,
        endTime: 0,
        showMenu: false,
        dialog: false,
        show_detail: '',
        page: 0,
        x: 0,
        y: 0,
        pageLoading: true,
        loadingMore: false,
        skeletonChatCount: 8,
        skeletonMoreCount: 3,
      }
    },
    components: {
      Longpress,
      InfiniteLoading
    },
    mounted () {
      // this.get_all_conversations()
      bus.$on('signalr_methods', (data) => {
        var self = this
        if (data[0] == 'is_typing') {
          this.fConversations.forEach(function (val) {
            if (data[1].sender == val.GetReceiver || data[1].sender == val.UserOrGroupId) {
              if (val._typingTimer) {
                clearTimeout(val._typingTimer)
                val._typingTimer = null
              }
              if (data[1].isTyping == 1 || data[1].isTyping === true) {
                Vue.set(val, 'typing_text', self.$t('isTyping'))
                val._typingTimer = setTimeout(function () {
                  Vue.set(val, 'typing_text', null)
                  val._typingTimer = null
                }, 4000)
              } else {
                Vue.set(val, 'typing_text', null)
              }
            }
          })
        }
        //* ***********************************
        if (data[0] == 'user_online') {
          var payload = data[1] || {}
          var userId = payload.userId || payload.UserId || payload.sender || payload.Sender || payload.UserOrGroupId || payload.GetReceiver
          var raw = payload.isOnline
          if (raw === undefined) raw = payload.IsOnline
          if (raw === undefined) raw = payload.Online
          if (raw === undefined) raw = payload.online
          if (raw === undefined) raw = payload.Status
          if (raw === undefined) raw = payload.status
          var online = raw === true || raw === 1 || raw === '1' || raw === 'online' || raw === 'Online'
          var offline = raw === false || raw === 0 || raw === '0' || raw === 'offline' || raw === 'Offline'
          if (!userId || (!online && !offline)) return
          this.fConversations.forEach(function (val) {
            if (userId == val.GetReceiver || userId == val.UserOrGroupId) {
              Vue.set(val, 'isOnline', online)
            }
          })
        }
        //* ***********************************
        if (data[0] == 'get_message') {
          this.fConversations.forEach(function (val) {
            if (data[1].ReceiverId == val.GetReceiver || data[1].CurrentUserId == val.GetReceiver) { Vue.set(val, 'MessageText', data[1].Message) }
            if (data[1].CurrentUserId == val.GetReceiver) {
              Vue.set(val, 'UnReadCount', val.UnReadCount + 1)
            }
          })
        }
        //* ***********************************
      })
    },
    watch: {
      searchQuery: function (val) {
        this.resultQuery()
      }
    },
    computed: {},
    methods: {
      finishInitialLoad () {
        if (this.pageLoading) {
          this.pageLoading = false
        }
      },
      infiniteHandler ($state) {
        var self = this
        console.log("infinite handler called")
        setTimeout(() => {
          self.page += 1
          if (!self.pageLoading) {
            self.loadingMore = true
          }
          self.get_all_conversations($state)
        }, 1000)
      },

      removeMessage () {
        this.dialog = true
      },

      openMenu (e, item) {
        console.log('open', item)
        this.show_detail = item
        e.preventDefault()
        this.showMenu = false
        this.x = e.clientX
        this.y = e.clientY
        this.$nextTick(() => {
          this.showMenu = true
        })
      },

      resultQuery () {
        this.fConversations = this.conversations.filter(post => {
          return post.ProcessName.toLowerCase().includes(this.searchQuery)
        })
      },

      goToDetail (item) {
        console.log('iteem', item)
        Vue.set(item, 'UnReadCount', 0)

        const last_chat_detail = {
          RecType: item.RecType,
          UserOrGroupId: item.UserOrGroupId,
          GetReceiver: item.GetReceiver
        }
        localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
        this.$router.push({ name: this.$t('conversation'), params: {} })
      },

      get_all_conversations ($state) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var phone = localStorage.getItem('phone')
        phone = phone.replace('+98', '')
        var password = localStorage.getItem('password')
        const send_data = {
          Phone: phone,
          Password: password,
          LastItemId: 0,
          Row: this.page,
        }
        // X-Content-Type-Options: nosniff
        const headers = {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        }
        // this.axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff' // for all requests

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetConversation', send_data, skeletonSilentRequest)
          .then(response => {
            const conversations = (response.data && response.data.conversation) || []
            if (response.data.error == 0) {
              self.date_now = response.data.dateNow

              conversations.forEach(function (number) {
                var last = String(number.LastSeenDate || number.LastSeen || '')
                if (number.isOnline == null && number.IsOnline == null) {
                  number.isOnline = last.indexOf('آنلاین') !== -1 || last.toLowerCase().indexOf('online') !== -1
                } else {
                  number.isOnline = number.isOnline === true || number.isOnline === 1 || number.IsOnline === true || number.IsOnline === 1
                }
                self.conversations.push(number)
                self.fConversations.push(number)
              })
            } else {
              self.not_register = true
            }
            if ($state != null) {
              if (conversations.length > 0) {
                console.log("get conv loaded")
                $state.loaded()
              } else {
                console.log("get conv complete")

                $state.complete()
              }
            }
            self.loadingMore = false
            self.finishInitialLoad()
          }).catch(e => {
          self.loadingMore = false
          if ($state != null) {
            $state.complete()
          }
          self.finishInitialLoad()
        })
      },
      convert_string_to_date (date) {
        var dateString = date

        var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
        var dateArray = reggie.exec(dateString)

        // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
        var dateObject = new Date(
          (+dateArray[3]),
          (+dateArray[2]), // Careful, month starts at 0!
          (+dateArray[1]),
          (+dateArray[4]),
          (+dateArray[5]),
          (+dateArray[5])
        )
        return dateObject.toDateString()
      },
      get_conversation_date(item) {
        var date = item.SubmitDateTimeMiladi
        var days = 0;
        var dateNow = new Date(this.convert_string_to_date(this.date_now))
        var conv_date = new Date(this.convert_string_to_date(date))
        // var conv_date_hour = new Date(date)
        var reportDate = date.substring(date.length-5)

        days = dateNow - conv_date;

        days = days / (1000 * 60 * 60 * 24)

        var ret;
        if (days < 1) {
          ret = reportDate;
        } else if (days >= 1 && days < 2) {
          ret = " دیروز " + reportDate;
        } else if ((days < 8) && (days > 1)) {
          ret = days + " روز قبل " + reportDate;

        } else {
          ret = item.SubmitDateTime.replace("-"," ");
        }

        return ret;
      },

      // get_conversation_date(date) {
      //   var days = 0;
      //   var dateNow = new Date(this.date_now)
      //   var conv_date = new Date(date)
      //
      //   var reportDate = conv_date.getHours() + ":" + conv_date.getMinutes()
      //   days = dateNow.getTime() - conv_date.getTime();
      //   days = days / (1000 * 60 * 60 * 24)
      //   var ret;
      //   if (days < 1) {
      //     ret = reportDate;
      //   } else if (days > 1 && days < 2) {
      //     ret = " دیروز " + reportDate;
      //   } else if ((days < 8) && (days > 1)) {
      //     ret = days + " روز قبل " + reportDate;
      //
      //   } else {
      //     ret = date;
      //   }
      //
      //   return ret;
      // },
      goToContact () {
        this.$router.push({ path: '/contacts', params: {} })
      },
    }
  }
</script>

<style scoped>
.scrollable-page {
  -webkit-overflow-scrolling: touch;
}

/* Search input with icon */
.search-wrapper { position: relative; }
.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #94a3b8;
}
.search-input {
  width: 100%;
  padding: 12px 14px 12px 38px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-size: 14px;
  outline: none;
}
.search-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96,165,250,0.25);
}

.chat-avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.online-pulse-dot {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
  animation: online-pulse 1.6s ease-out infinite;
  z-index: 2;
}

@keyframes online-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.55);
    transform: scale(1);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(34, 197, 94, 0);
    transform: scale(1.05);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0);
    transform: scale(1);
  }
}

/* Chat item spacing */
.chats-list-container { background: transparent; }
.chat-item { margin-bottom: 10px; }
.chat-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}

.context-menu {
  position: fixed;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 150px;
  overflow: hidden;
}

.menu-item {
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
}

.menu-item:hover {
  background: #f9fafb;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-icon {
  margin-left: 8px;
  font-size: 14px;
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.chats-skeleton-group {
  position: relative;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.chats-skeleton-group::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 45%,
    rgba(255, 255, 255, 0.65) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: chats-skeleton-shimmer 1.4s ease-in-out infinite;
}

.skeleton-block {
  background-color: #e5e7eb;
}

.skeleton-avatar {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  flex-shrink: 0;
}

.skeleton-line {
  border-radius: 6px;
}

.skeleton-line-md {
  width: 9rem;
  height: 0.875rem;
}

.skeleton-line-sm {
  width: 70%;
  height: 0.75rem;
}

.skeleton-line-date {
  width: 2.5rem;
  height: 0.75rem;
  flex-shrink: 0;
}

.chats-more-skeleton-group {
  position: relative;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
}

.chats-more-skeleton-group::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.55) 45%,
    rgba(255, 255, 255, 0.65) 55%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: chats-skeleton-shimmer 1.4s ease-in-out infinite;
}

@keyframes chats-skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
</style>
